import { cn } from '@seen/ui'
import type { HTMLAttributes } from 'react'
import { useFormField } from '#src/hooks/useFormField.ts'
import { forwardRef } from '#src/utils/forwardRef.ts'

export const FormErrorMessage = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => {
  const { error, formErrorMessageId } = useFormField()
  const body = error ? String(error?.message) : children

  if (!body) {
    return null
  }

  return (
    <p
      ref={ref}
      id={formErrorMessageId}
      className={cn('font-medium text-destructive text-sm', className)}
      {...props}
    >
      {body}
    </p>
  )
})
